export default "__VITE_ASSET__IZFkx8cs__"